var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RetailHeader',{attrs:{"img_header":_vm.header_image,"header":"ประวัติการขอเอกสาร (Document history)","link_back":"user/retailgeneral"}}),_c('General_Retail_document_history')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }